import React, { useState, useEffect, useRef } from "react";
import Title from "../Title/Title";
import Button from "../Button/Button";
import Paragraph from "../Paragraph/Paragraph";
import styles from "./Result.module.scss";
import classNames from "classnames";
import { SITE_URL } from "../../state/consts";
import { IconButton, Snackbar } from "@mui/material";
import ShareIcon from "@mui/icons-material/Share";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";

import { FacebookShareButton, WhatsappShareButton } from "react-share";

import { FacebookIcon, WhatsappIcon } from "react-share";

function Result({
  score,
  title,
  text,
  imageSrc,
  posterContainer,
  optionsContainer,
}) {
  const [offset, setOffset] = useState(false);
  const [copySuccess, setCopySuccess] = useState("");
  const [showConditions, setShowConditions] = useState(false);
  const textAreaRef = useRef(null);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 50) {
        setOffset(true);
      } else {
        setOffset(false);
      }
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const ImageURL = SITE_URL + imageSrc;

  // кнопка скопировать
  const [open, setOpen] = useState(false);

  const testClick = () => {
    setOpen(true);
    navigator.clipboard.writeText(window.location.toString());
  };

  function copyToClipboard(e) {
    textAreaRef.current.select();
    console.log(textAreaRef.current.value);
    document.execCommand("copy");
    e.target.focus();
    setCopySuccess(
      <div className={styles.copySuccess}>Промокод скопирован.</div>,
    );

    setTimeout(() => {
      setCopySuccess(
        <div className={classNames(styles.copySuccess, styles.displayNone)}>
          Промокод скопирован.
        </div>,
      );
    }, "1500");
  }

  return (
    <>
      {!showConditions ? (
        <>
          <div className={posterContainer}>
            <img src={imageSrc} className={styles.image} alt="" />
          </div>
          <div className={classNames(optionsContainer, styles.before)}>
            <div
              className={classNames({
                [styles.resultPosterContainer]: true,
                [styles.onScrollOption]: offset,
              })}
            >
              <div className={styles.contentWrapper}>
                <div className={styles.score}>{score}</div>
                <Title value={title} />
                {text}
              </div>

              <div className={styles.promoBox}>
                <div className={styles.promoButtonsWrapper}>
                  <div className={styles.promoWrapper}>
                    <div className={styles.inputPromoWrapper}>
                      <form className={styles.form}>
                        <input
                          ref={textAreaRef}
                          value="SPICY"
                          className={styles.inputPromo}
                          readOnly
                        />
                      </form>

                      <button onClick={copyToClipboard} className={styles.copy}>
                        <ContentCopyIcon />
                      </button>
                    </div>
                  </div>

                  <div className={styles.buttonBox}>
                    <a
                      href="https://taximaxim.onelink.me/KKXl?pid=TH_Quiz&deep_link_value=maximzakaz%3A%2F%2F&deep_link_sub1=app%3Faction%3Dpromo%26code%3DSPICY&af_dp=maximzakaz%3A%2F%2Fapp%3Faction%3Dpromo%26code%3DSPICY&af_web_dp=https%3A%2F%2Ftaximaxim.com%2Fapp&c=pm2811220526"
                      target="_blank"
                      rel="noreferrer"
                    >
                      <Button
                        value="รับโค้ดส่วนลด"
                        className={styles.buttonPresent}
                      />
                    </a>

                    <div
                      className={styles.buttonBoxLink}
                      onClick={() => {
                        setShowConditions(true);
                      }}
                    >
                      เงื่อนไขโปรโมชัน
                    </div>
                  </div>
                </div>
              </div>

              <div
                className={classNames(
                  styles.contentWrapper,
                  styles.socialWrapper,
                )}
              >
                <Paragraph value="แชร์" />
                <div className={styles.social}>
                  <FacebookShareButton
                    url={SITE_URL}
                    title="ฉันเช็กระดับความแซ่บของตัวเองแล้ว 🌶️ ตาคุณแล้วนะ ลองเช็กดูหรือยัง? มีส่วนลดรออยู่ตอนท้ายด้วย"
                    image={ImageURL}
                    hashtag="#Maxim"
                    id="facebook"
                  >
                    <FacebookIcon
                      size={48}
                      round={true}
                      className={classNames(styles.icon, styles.facebook)}
                    />
                  </FacebookShareButton>

                  <WhatsappShareButton
                    url={SITE_URL}
                    title="ฉันเช็กระดับความแซ่บของตัวเองแล้ว 🌶️ ตาคุณแล้วนะ ลองเช็กดูหรือยัง? มีส่วนลดรออยู่ตอนท้ายด้วย"
                    image={ImageURL}
                    id="whatsapp"
                  >
                    <WhatsappIcon
                      size={48}
                      round={true}
                      className={classNames(styles.icon, styles.whatsapp)}
                    />
                  </WhatsappShareButton>

                  <div id="sharelink">
                    <IconButton
                      onClick={testClick}
                      color="primary"
                      className={styles.share}
                    >
                      <ShareIcon />
                    </IconButton>
                    <Snackbar
                      message="คัดลอกลิงก์"
                      anchorOrigin={{ vertical: "top", horizontal: "center" }}
                      autoHideDuration={1000}
                      onClose={() => setOpen(false)}
                      open={open}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
          {copySuccess}
        </>
      ) : (
        <>
          <div className={styles.posterContainer}>
            <img src={imageSrc} className={styles.image} alt="" />
          </div>
          <div className={styles.resultContainer} m2>
            <div
              className={classNames({
                [styles.resultContainerBox]: true,
                [styles.onScrollOption]: offset,
              })}
            >
              <div>
                <Title value="ระยะเวลาโปรโมชันตั้งแต่วันที่ 1 มิถุนายน 2026 ถึง 31 ธันวาคม 2026" />
                <Paragraph value="เงินโบนัสสามารถใช้ชำระค่าใช้จ่ายได้สูงสุด 10% ของการเดินทางของคุณภายใน 7 วันหลังจากเปิดใช้งานรหัสโปรโมชั่น ส่วนลดสูงสุดไม่เกิน 200 บาท เงื่อนไขเป็นไปตามที่บริษัทฯกำหนด" />
                <Button
                  className={styles.buttonConditions}
                  value="ย้อนกลับ"
                  onClick={() => {
                    setShowConditions(false);
                  }}
                />
              </div>
            </div>
          </div>
        </>
      )}
    </>
  );
}

export default Result;
